export const buildEnvironment = {
"buildId":"73144",
"buildDate":"2021-07-23T04:26:58.290Z",
"buildTimeStamp":1627014418290,
"ngVersion":"9.1.4",
"version":"5.4.3697",
"api":"+19.11",
"environment":"prod",
"production":true
};